import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import QuestionCard from './QuestionCard';

/** فئة التصوير — الخطوة الأولى (إجبارية) */
const OPTIONS = [
  {
    value: 'commercial',
    label: 'تصوير تجاري',
    description: 'للتصوير المرتبط بالأنشطة والمحتوى التسويقي',
    icon: 'Briefcase',
  },
  {
    value: 'individual',
    label: 'تصوير الأفراد',
    description: 'للمناسبات الشخصية، الصور الشخصية، والجلسات الخاصة',
    icon: 'Users',
  },
];

const PhotographyCategoryStep = ({ formData, onUpdate }) => {
  const [selected, setSelected] = useState(formData?.photographyCategory || '');

  useEffect(() => {
    if (formData?.photographyCategory && formData.photographyCategory !== selected) {
      setSelected(formData.photographyCategory);
    }
  }, [formData?.photographyCategory]);

  const handleSelect = (opt) => {
    setSelected(opt.value);
    onUpdate({
      photographyCategory: opt.value,
      photographyCategoryLabel: opt.label,
    });
  };

  return (
    <QuestionCard
      icon="Layers"
      title="فئة التصوير"
      description="اختر فئة التصوير المناسبة لك"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => handleSelect(opt)}
            className={`p-5 rounded-2xl border-2 text-right transition-all hover:border-primary hover:bg-primary/5 ${
              selected === opt.value
                ? 'border-primary bg-primary/10 shadow-md ring-2 ring-primary/20'
                : 'border-slate-200 bg-white'
            }`}
          >
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    selected === opt.value ? 'bg-primary/20' : 'bg-slate-100'
                  }`}
                >
                  <Icon
                    name={opt.icon}
                    size={24}
                    className={selected === opt.value ? 'text-primary' : 'text-slate-500'}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-lg font-bold text-slate-900 block">{opt.label}</span>
                </div>
                <div
                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                    selected === opt.value
                      ? 'border-primary bg-primary'
                      : 'border-slate-300 bg-white'
                  }`}
                >
                  {selected === opt.value && (
                    <Icon name="Check" size={14} className="text-white" />
                  )}
                </div>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed pr-0 md:pr-1">{opt.description}</p>
            </div>
          </button>
        ))}
      </div>
    </QuestionCard>
  );
};

export default PhotographyCategoryStep;
